import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=13bcf8a2&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"
import style0 from "./Heading.vue?vue&type=style&index=0&id=13bcf8a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bcf8a2",
  null
  
)

export default component.exports